import { ComputeFieldComponent } from "../computeFields";
import { Auction } from "../types";
import { SeparatedList } from "./shared/utils";

export const AuctionSummaryCF: ComputeFieldComponent<
  Pick<
    Auction,
    | "ventesDescriptionDate"
    | "ventesDescriptionCommissaires"
    | "ventesDescriptionLieu"
    | "ventesDescriptionVille"
    | "ventesDescriptionPays"
  >
> = ({ input, lineBreak = false, ...props }) => {
  const resumeItems = [
    input.ventesDescriptionDate,
    input.ventesDescriptionCommissaires,
    input.ventesDescriptionLieu,
    input.ventesDescriptionVille,
    input.ventesDescriptionPays,
  ].filter((item) => !!item);
  return <SeparatedList input={resumeItems} lineBreak={lineBreak} {...props} />;
};
